module.exports = __webpack_public_path__ + "media/application/images/features/inventory-linking-1100-85ab6e48f72183ece9ec2c0208ea9cae.png";